export class ColorScheme {
  constructor(private scheme: string[]) {}
  getColorFromScheme(rnd?: number) {
    const colorIndex = (rnd || 1) % this.scheme.length;
    return this.scheme[colorIndex];
  }
}
